module.exports = __webpack_public_path__ + "static/media/error_popup_icon.f32434ca.svg";